import React from 'react';
import { Control } from 'react-hook-form';
import TextComponent from '/components/forms-v2/Text.component';

interface PasswordInputProps {
  control: Control<any, any>;
  disableHelper?: boolean;
  name?: string;
  label?: string;
  rules?: {
    [x: string]: any;
  };
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  control,
  disableHelper,
  name = 'password',
  label = 'Password',
  rules,
}) => {
  return (
    <TextComponent
      name={name}
      control={control}
      label={label}
      rules={{
        required: { value: true, message: 'Enter password' },
        minLength: { value: 8, message: 'Password is too short' },
        ...rules,
      }}
      type="password"
      helperText={!disableHelper ? 'Minimum 8 characters' : undefined}
    />
  );
};

export default PasswordInput;
